"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Overlay: () => Overlay
});
module.exports = __toCommonJS(src_exports);

// ../stories-api-client/dist/index.js
var getItems = (client, provider) => async ({
  assetIds
}, options) => {
  if (!assetIds.length) {
    return { items: [] };
  }
  const searchParams = new URLSearchParams({ assetId: [...assetIds].sort().join(",") });
  if (provider) {
    searchParams.set("provider", provider);
  }
  const response = await client("/items", { ...options, searchParams });
  return response.json();
};
var getRelatedItems = (client, provider) => async ({
  assetId,
  playlistId
}, options) => {
  const searchParams = new URLSearchParams({ assetId: String(assetId) });
  if (playlistId) {
    searchParams.set("playlistId", playlistId);
  }
  if (provider) {
    searchParams.set("provider", provider);
  }
  const response = await client("/related-items", {
    ...options,
    searchParams
  });
  return response.json();
};
var createStoriesApi = (client, provider) => {
  return {
    getItems: getItems(client, provider),
    getRelatedItems: getRelatedItems(client, provider)
  };
};

// ../http-client/dist/index.js
var HttpError = class extends Error {
  constructor(response) {
    const code = response.status || response.status === 0 ? response.status : "";
    const title = response.statusText || "";
    const status = `${code} ${title}`.trim();
    const reason = status ? `status code ${status}` : "an unknown error";
    super(`Request failed with ${reason}`);
    this.name = "HttpError";
    this.response = response;
  }
};
var resolveFetch = () => {
  try {
    if (typeof window !== "undefined" && "fetch" in window) {
      return fetch;
    } else if ("fetch" in globalThis) {
      return fetch;
    }
  } catch (e) {
    console.error('failed to resolve "fetch"', e);
  }
  return void 0;
};
var getSignal = (timeout) => {
  if (!timeout) {
    return {
      signal: void 0,
      clear: () => {
      }
    };
  }
  const controller = new AbortController();
  const timer = setTimeout(() => {
    controller.abort();
  }, timeout);
  const clear = () => {
    clearTimeout(timer);
  };
  return {
    signal: controller.signal,
    clear
  };
};
var createClient = ({
  baseUrl,
  timeout: defaultTimeout,
  fetch: fetch2 = resolveFetch()
}) => {
  const normalizedBaseUrl = baseUrl.replace(/\/$/, "");
  return async (url, options = {}) => {
    const { searchParams, timeout = defaultTimeout, ...init } = options;
    const controller = getSignal(timeout);
    let input = `${normalizedBaseUrl}${url}`;
    if (searchParams) {
      const params = new URLSearchParams(searchParams).toString();
      input += `?${params}`;
    }
    const response = await fetch2(input, { ...init, signal: controller.signal });
    controller.clear();
    if (!response.ok) {
      throw new HttpError(response);
    }
    return response;
  };
};

// src/helpers.ts
var resolveBaseUrl = () => {
  return `${window.location.origin}/stories`;
};
var createIframeElement = (baseUrl, provider) => {
  let url = `${baseUrl}/embed`;
  if (provider) {
    url += `?provider=${provider}`;
  }
  const iframe = document.createElement("iframe");
  iframe.setAttribute("allow", "autoplay; web-share");
  iframe.setAttribute("src", url);
  iframe.style.position = "fixed";
  iframe.style.left = "0px";
  iframe.style.right = "0px";
  iframe.style.top = "0px";
  iframe.style.bottom = "0px";
  iframe.style.display = "none";
  iframe.style.width = "100%";
  iframe.style.height = "100%";
  iframe.style.border = "none";
  iframe.style.backgroundColor = "#fff";
  iframe.className = "stories-overlay";
  return iframe;
};
var resolveAssetId = (url) => {
  try {
    const { pathname } = new URL(url);
    const { groups } = pathname.match(/^\/stories\/(?<id>(\d+))/) || {};
    return parseInt((groups == null ? void 0 : groups.id) || "", 10) || void 0;
  } catch {
    return void 0;
  }
};

// src/index.ts
var Overlay = class extends EventTarget {
  constructor(options = {}) {
    var _a, _b;
    super();
    this.isIframeReady = false;
    this.state = "closed";
    this.baseUrl = (_a = options.baseUrl) != null ? _a : resolveBaseUrl();
    this.items = /* @__PURE__ */ new Map();
    this.provider = options.provider;
    this.storiesApi = createStoriesApi(
      createClient({ baseUrl: `${this.baseUrl}/api`, timeout: (_b = options.timeout) != null ? _b : 1500 }),
      this.provider
    );
  }
  init() {
    if (this.iframe) {
      return;
    }
    this.iframe = createIframeElement(this.baseUrl, this.provider);
    document.body.appendChild(this.iframe);
    const listener = (e) => {
      try {
        const event = JSON.parse(e.data);
        switch (event.type) {
          case "overlay/go-back": {
            this.dispatch("overlay/go-back");
            break;
          }
          case "overlay/state": {
            this.dispatch("overlay/state", event.payload);
            break;
          }
          case "overlay/ready": {
            this.isIframeReady = true;
            break;
          }
        }
      } catch {
      }
    };
    window.addEventListener("message", listener);
    this.removeIframeListener = () => {
      window.removeEventListener("message", listener);
    };
  }
  destroy() {
    var _a;
    (_a = this.removeIframeListener) == null ? void 0 : _a.call(this);
    this.state = "closed";
    this.isIframeReady = false;
    if (this.iframe) {
      document.body.removeChild(this.iframe);
      this.iframe = void 0;
    }
  }
  async preloadItem(url) {
    await this.getItem(url);
  }
  async preloadItems(urls) {
    const assetIds = urls.map((url) => resolveAssetId(url)).filter((id) => Boolean(id)).filter((id) => !this.items.has(id));
    const getItemsPromise = this.storiesApi.getItems({ assetIds });
    const getItem = async (assetId) => {
      try {
        const { items } = await getItemsPromise;
        return items.find((item) => item.type === "asset" && item.asset.id === assetId);
      } catch (err) {
        console.error(err);
        return void 0;
      }
    };
    assetIds.forEach((assetId) => {
      this.items.set(assetId, getItem(assetId));
    });
  }
  async openItem(url) {
    const iframe = this.iframe;
    if (!iframe) {
      return false;
    }
    const item = await this.getItem(url);
    if (!item) {
      return false;
    }
    const success = this.postMessage({
      type: "overlay/set-item",
      payload: { item, url }
    });
    if (success) {
      this.dispatch("overlay/open");
      this.state = "open";
      iframe.style.display = "unset";
    }
    return success;
  }
  getItem(url) {
    const assetId = resolveAssetId(url);
    if (!assetId) {
      return void 0;
    }
    let item = this.items.get(assetId);
    if (!item) {
      item = this.fetchItem(assetId);
      this.items.set(assetId, item);
    }
    return item;
  }
  closeOverlay() {
    if (!(this.iframe && this.state === "open")) {
      return;
    }
    this.state = "closed";
    this.iframe.style.display = "none";
    this.postMessage({ type: "overlay/close" });
    this.dispatch("overlay/close");
  }
  async fetchItem(assetId) {
    try {
      const { items } = await this.storiesApi.getItems({ assetIds: [assetId] });
      return items.find((item) => item.type === "asset" && item.asset.id === assetId);
    } catch (err) {
      console.error(err);
      return void 0;
    }
  }
  postMessage(message) {
    if (!(this.iframe && this.iframe.contentWindow && this.isIframeReady)) {
      return false;
    }
    this.iframe.contentWindow.postMessage(JSON.stringify(message), "*");
    return true;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch(type, detail) {
    const event = detail ? new CustomEvent(type, { detail }) : new Event(type);
    this.dispatchEvent(event);
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Overlay
});
